module.exports = __webpack_public_path__ + "static/media/dilly.feb1e91c.mp4";